import Image from "next/image";
import axios from "axios";
import { GetServerSidePropsContext } from "next";
import MarketingEnrollNowForm from "@/components/Masterclass/MarketingPaidForm";
import React from "react";
import { useRouter } from "next/router";
import Head from "next/head";

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const id = "clw957zzy05ngpcbinwpsxwv7";
  const host = context.req?.headers.host;
  const protocol = context.req?.headers["x-forwarded-proto"] || "http";
  const fullDomain = `${protocol}://${host}`;

  try {
    const { data } = await axios.get(
      `${process.env.NEXT_PUBLIC_BASE_API}masterclasses/${id}`,
      {
        headers: {
          "Accept-Encoding": "gzip",
        },
      }
    );

    return {
      props: {
        id: id,
        masterclass: data.data,
        fullDomain: fullDomain,
      },
    };
  } catch (err) {
    return {
      props: {
        masterclass: null,
        id: "",
        fullDomain: "https://www.tradewiseapp.com/",
      },
    };
  }
}

function chatgpt({
  id,
  masterclass,
  fullDomain,
}: {
  id: string;
  masterclass: any;
  fullDomain: string;
}) {
  const [isEnrollNowFormOpen, setIsEnrollNowFormOpen] = React.useState(false);
  const handleLeadModalOpen = () => {
    setIsEnrollNowFormOpen(true);
  };
  const router = useRouter();
  const source = router.query.source;
  const leadComment = router.query.comment;
  const backComment = source === "google" ? "paidMasterClass" : "paidBootcamp";

  if (typeof window !== "undefined" && !masterclass) {
    window.location.href = "https://www.tradewiseapp.com/masterclasses";
  }
  const slots = masterclass?.slots;
  const activeSlot = slots?.find((slot: any) => {
    return slot.active;
  });
  const token =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOjQ5LCJpYXQiOjE3NDQ0NDAyMzV9.grKK26hq373iIppM-D6lt7RbEZOPw4wUcrW-F5Bj0Mo";
  const redirectURL = `${fullDomain}/${id}/redirect/thanks-paid?ref=chatgpt`;
  return (
    <>
      <Head>
        <title>ChatGPT Prompts | Tradewise</title>
        <meta
          name="description"
          content="Optimize your trading strategy with AI-driven ChatGPT prompts for actionable insights. Identify the best stocks to buy, determine the ideal entry and exit points, and understand market trends with precision."
        />
        <script
          dangerouslySetInnerHTML={{
            __html: `
             (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-5G6WR26B');
          `,
          }}
        />
      </Head>
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-5G6WR26B"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        ></iframe>
      </noscript>
      <MarketingEnrollNowForm
        masterClassData={masterclass}
        isOpen={isEnrollNowFormOpen}
        activePaidSlotInfo={activeSlot}
        closeModal={() => {
          setIsEnrollNowFormOpen(false);
        }}
        source={source}
        leadComment={leadComment}
        backComment={backComment}
        fullDomain={fullDomain}
        masterClassId={id}
        customToken={token}
        buttonClass="!bg-[#408870]"
        buttonText="Get Prompts"
        customRedirect={redirectURL}
      />
      <main className="w-full min-h-screen bg-[url(/marketing/chatgptBcg.png)] bg-cover bg-no-repeat grid md:grid-cols-2 md:px-28 items-center justify-center px-6">
        <Image
          src="/logo.svg"
          alt="chatgpt logo"
          height={120}
          width={120}
          className=" top-14 right-32 absolute max-md:hidden"
        />
        <div className="col-span-1 grid font-inter max-md:place-items-center max-md:text-center max-md:gap-2">
          <Image
            src="/logo.svg"
            alt="chatgpt logo"
            height={100}
            width={100}
            className="md:hidden"
          />
          <Image
            src="/marketing/chatGpt.png"
            alt="chatgpt logo"
            height={150}
            width={150}
            className=" animate-pulse"
          />
          <h3 className="text-2xl font-bold">Transform Your Trading</h3>
          <h1 className="text-4xl md:text-6xl md:leading-[66px] font-semibold leading-[50px]">
            Achieve Your <br />{" "}
            <span className="text-[#408870]">₹1CR Goal</span> with AI{" "}
          </h1>
          <p className="text-gray-800">
            Optimize your trading strategy with AI-driven ChatGPT prompts for
            actionable insights.
          </p>
          <p className="p-2 bg-gradient-to-r to-[#E5F8F0] from-[#b8e7d4] rounded-md md:w-2/3 mt-3 min-w-full">
            Identify the best stocks to buy
          </p>
          <p className="p-2 bg-gradient-to-r to-[#E5F8F0] from-[#b8e7d4] rounded-md md:w-2/3 mt-3 min-w-full">
            Determine the ideal entry and exit points
          </p>
          <p className="p-2 bg-gradient-to-r to-[#E5F8F0] from-[#b8e7d4] rounded-md md:w-2/3 mt-3 min-w-full">
            Understand market trends with precision
          </p>
          <button
            className="bg-[#408870] p-4 rounded-md mt-5 text-xl md:text-xl !text-white hover:!text-white hover:scale-105"
            onClick={handleLeadModalOpen}
          >
            Get ChatGPT Prompts For Steady Profits at ₹49{" "}
          </button>
        </div>
      </main>
    </>
  );
}

export default chatgpt;
